import { onMounted, ref } from '@nuxtjs/composition-api'
import GgoTrackKey from '@/enums/GgoTrackKey'
import { getActivator } from '@/modules/omnichat-activator'
import html2canvas from 'html2canvas'

export default function () {
  const omnichatActivator = ref<HTMLElement>()
  onMounted(async () => {
    omnichatActivator.value = await getActivator()
  })

  const copied = ref(false)

  const getTrackUrl = (_url?: string) => {
    const url = _url || window.location.href
    return appendTrackingCode(url)
  }

  const copyCurrentUrl = (url?: string) => {
    navigator.clipboard?.writeText(getTrackUrl(url))
    copied.value = true

    setTimeout(() => {
      copied.value = false
    }, 2000)
  }

  const appendTrackingCode = (_url: string) => {
    const url = new URL(_url)
    url.searchParams.set(GgoTrackKey.REFERRAL, 'true')
    return url.toString()
  }

  const nativeShare = (shareData: ShareData) => {
    navigator.share?.(shareData)
  }

  const capturePageToCanvas = async () => {
    try {
      const promotionImg = document.querySelector('.order-result-promotion-image') as HTMLImageElement
      if (promotionImg) {
        promotionImg.style.width = '500px'
        promotionImg.style.height = 'auto'
      }
      if (omnichatActivator.value) { omnichatActivator.value.style.visibility = 'hidden' }

      const canvas = await html2canvas(document.body, {
        // allowTaint: true,
        useCORS: true,
        proxy: 'https://gogoout.com',
        windowWidth: 600,
        width: 600,
        ignoreElements (element) {
          return element.classList.contains('driver-information')
        },
        onclone: () => {
          if (promotionImg) {
            promotionImg.style.width = '100%'
            promotionImg.style.height = 'auto'
          }
          if (omnichatActivator.value) { omnichatActivator.value.style.visibility = 'visible' }
        },
        scale: 1,
      })

      return canvas
    } catch (err) {
      console.error(err)
    }
  }

  return {
    copied,
    getTrackUrl,
    copyCurrentUrl,
    nativeShare,
    capturePageToCanvas,
  }
}
